//POSITION
export const apiGetAllPosition = "Position/GetListPositionForCombobox"
export const apiGetListPosition = "Position/GetList"
export const apiCreate = "Position/Create"
export const apiDelete = "Position/Delete"
export const apiUpdate = "Position/Update"
export const apiGetAllTitle = "Position/GetListTitleForCombobox"
export const apiImportPosition = "Position/ImportPosition"
